import { c as _c } from "react/compiler-runtime";
import { IcoArrowTopRight16, IcoFileText16, IcoSearch16 } from '@onefootprint/icons';
import type { AgentRunOutputWatchlistReview } from '@onefootprint/request-types/dashboard';
import { Divider, LinkButton } from '@onefootprint/ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import SummaryBox from '../summary-box';
type WatchlistAgentExecutionSummaryProps = {
  output: AgentRunOutputWatchlistReview;
};
const WatchlistAgentExecutionSummary = t0 => {
  const $ = _c(21);
  const {
    output
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "agentExecutionSummary.watchlistReview"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const {
    recommendation,
    reasoningSummary,
    auditTrail,
    webSearches
  } = output;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <IcoFileText16 />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t) {
    t3 = t(_temp);
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <div className="flex gap-1 items-center">{t2}<h2 className="text-label-2 text-primary">{t3}</h2></div>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== reasoningSummary || $[7] !== recommendation) {
    t5 = <SummaryBox recommendation={recommendation} reasoningSummary={reasoningSummary} />;
    $[6] = reasoningSummary;
    $[7] = recommendation;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== auditTrail) {
    t6 = auditTrail.map(_temp2);
    $[9] = auditTrail;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t || $[12] !== webSearches) {
    t7 = webSearches.length > 0 && <><Divider className="border-tertiary" /><div className="flex gap-1 items-center"><IcoSearch16 /><h2 className="text-label-2 text-primary">{t(_temp3)}</h2></div>{webSearches.map(_temp4)}</>;
    $[11] = t;
    $[12] = webSearches;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t5 || $[15] !== t6 || $[16] !== t7) {
    t8 = <div className="flex flex-col gap-6">{t5}{t6}{t7}</div>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t4 || $[19] !== t8) {
    t9 = <div className="flex flex-col gap-4 pb-4">{t4}{t8}</div>;
    $[18] = t4;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
};
const WebSearchItem = t0 => {
  const $ = _c(31);
  const {
    query,
    urls
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "agentExecutionSummary.watchlistReview.webSearches"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const [isExpanded, setIsExpanded] = useState(false);
  let t2;
  if ($[1] !== isExpanded || $[2] !== urls) {
    t2 = isExpanded ? urls : urls.slice(0, 3);
    $[1] = isExpanded;
    $[2] = urls;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const urlsToDisplay = t2;
  const onWheelCapture = _temp5;
  const onTouchMoveCapture = _temp6;
  let t3;
  if ($[4] !== t) {
    t3 = t(_temp7);
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <span className="text-label-2 text-primary">{t3}</span>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== query) {
    t5 = <span className="text-body-2 text-tertiary">{query}</span>;
    $[8] = query;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <div className="flex flex-col gap-1">{t4}{t5}</div>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t(_temp8);
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t7) {
    t8 = <span className="text-label-2 text-primary">{t7}</span>;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== urlsToDisplay) {
    let t10;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = (url, index) => <div key={url} className="flex gap-2 items-center" onWheelCapture={onWheelCapture} onTouchMoveCapture={onTouchMoveCapture}><p className="bg-secondary rounded-sm w-5 h-5 shrink-0 flex items-center justify-center text-caption-1 text-primary ">{index + 1}</p><a href={url} target="_blank" rel="noopener noreferrer" className="flex gap-1 items-center max-w-[420px] max-md:min-w-0 text-body-2 text-tertiary hover:text-primary group"><span className="overflow-hidden text-ellipsis whitespace-nowrap">{url}</span><IcoArrowTopRight16 className="flex-shrink-0 mt-0.5 opacity-0 group-hover:opacity-100" /></a></div>;
      $[19] = t10;
    } else {
      t10 = $[19];
    }
    t9 = urlsToDisplay.map(t10);
    $[17] = urlsToDisplay;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[20] !== t8 || $[21] !== t9) {
    t10 = <div className="flex flex-col gap-1">{t8}{t9}</div>;
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== isExpanded || $[24] !== t || $[25] !== urls.length) {
    t11 = urls.length > 3 && <LinkButton onClick={() => setIsExpanded(!isExpanded)}>{isExpanded ? t(_temp9) : t(_temp10)}</LinkButton>;
    $[23] = isExpanded;
    $[24] = t;
    $[25] = urls.length;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t10 || $[28] !== t11 || $[29] !== t6) {
    t12 = <div className="flex flex-col gap-3 pl-3 border-l-2 border-gray-100">{t6}{t10}{t11}</div>;
    $[27] = t10;
    $[28] = t11;
    $[29] = t6;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  return t12;
};
export default WatchlistAgentExecutionSummary;
function _temp($) {
  return $.title;
}
function _temp2(auditTrail_0) {
  return <div key={auditTrail_0.title} className="flex flex-col gap-3"><span className="text-label-2 text-primary">{auditTrail_0.title}</span><span className="text-body-2 text-secondary">{auditTrail_0.description}</span></div>;
}
function _temp3($_0) {
  return $_0.webSearches.title;
}
function _temp4(t0) {
  const {
    query,
    urls
  } = t0;
  return <WebSearchItem key={query} query={query} urls={urls} />;
}
function _temp5(e) {
  e.stopPropagation();
}
function _temp6(e_0) {
  e_0.stopPropagation();
}
function _temp7($) {
  return $.query;
}
function _temp8($_0) {
  return $_0.sources;
}
function _temp9($_1) {
  return $_1.showFewerSources;
}
function _temp10($_2) {
  return $_2.showAllSources;
}